import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { openInteractiveDemo } from "../components/demo/DemoLauncher";

// L'URL /demo est conservée : elle renvoie vers l'accueil et ouvre la démo interactive officielle.
export default function Demo() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/", { replace: true });
    const t = setTimeout(openInteractiveDemo, 300);
    return () => clearTimeout(t);
  }, [navigate]);
  return null;
}
